﻿import React, { useState, useEffect } from 'react';
import { ProductBatchListItem } from '../models/product-batch-list-item';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { BenchSheetParentReference } from '../models/bench-sheet-parent-reference';
import { ModalMetadata } from '../models/modal-metadata';
import { MessageBoxReplyType, ModalMessageType } from '../models/enums';
import { MessageBoxReply } from '../models/message-box-reply';

import DataGrid, {
    Column,
    Selection,
    Paging,
    Toolbar,
    Item as ToolBarItem,
    Button as ColumnButton,
    LoadPanel
} from 'devextreme-react/data-grid';

import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';

const DELETE_BATCHES_BENCH_SHEET_WARNING = 100;

export interface Props {
    benchSheetId: string;
    onClose?: () => void;
}

export default function BenchSheetBatchReferencesComponent(props: Props) {
    const [referencedBatches, setReferencedBatches] =
        useState<ProductBatchListItem[]>();

    const [batches, setBatches] =
        useState<ProductBatchListItem[]>();

    const [searchString, setSearchString] =
        useState<string>();

    const [selectedBatches, setSelectedBatches] =
        useState<BenchSheetParentReference[]>();

    const [deleteBatchReferenceId, setDeleteBatchReferenceId] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.benchSheetId]);

    return (
        <div>
            <div className="pw-comp-row">
                <div className="form-unit">
                    <TextBox id="searchString" className="textbox"
                        onValueChanged={onSearchStringValueChanged}
                        placeholder='search...'
                        value={searchString ? searchString : undefined} />
                </div>
                <div className="form-unit pw-margin-left-1">
                    <Button id="searchBatchesButton"
                        text="Search Batches" icon="find" type="success" onClick={onSearchBatchesClick} />
                </div>

            </div>

            <div>
                <DataGrid
                    height="15rem"
                    allowColumnResizing={true}
                    columnResizingMode="nextColumn"
                    wordWrapEnabled={true}
                    dataSource={batches ? batches : []}
                    onSelectionChanged={onBatchesSelectionChanged}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode='multiple' />

                    {/*
                    <Column dataField='fullBatchName' caption="Full Name" dataType="string" width='16rem' />
                    */}

                    <Column dataField='batchName' dataType="string" width='10rem' />
                    <Column dataField='catalogNumber' caption="Catalog#" dataType="string" width='10rem' />
                    <Column dataField='batchVersion' caption="Version" dataType="number" width='6rem' />
                    <Column dataField='batchTypeString' caption="Batch Type" dataType="string" width='12rem' />
                    <Column />

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Batches Search</div>
                            </div>
                        </ToolBarItem>
                        <ToolBarItem location='after'>
                            <Button id="addSelectedBatchesButton" type='normal'
                                hint='Add Selected Batches' icon='plus'
                                width='1.8rem'
                                onClick={onAddSelectedBatchesClick} />
                        </ToolBarItem>
                    </Toolbar>

                </DataGrid>
            </div>

            <div className="pw-margin-top-1">
                <DataGrid
                    height="13rem"
                    allowColumnResizing={true}
                    columnResizingMode="nextColumn"
                    wordWrapEnabled={true}
                    dataSource={referencedBatches ? referencedBatches : []}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode='single' />

                    {/*
                    <Column dataField='fullBatchName' caption="Full Name" dataType="string" width='16rem' />
                    */}

                    <Column type="buttons" width='3rem'>
                        <ColumnButton icon="trash" hint="Delete"
                            onClick={onRemoveBatchReferenceClick} />
                    </Column>

                    <Column dataField='batchName' dataType="string" width='10rem' />
                    <Column dataField='catalogNumber' caption="Catalog#" dataType="string" width='10rem' />
                    <Column dataField='batchVersion' caption="Version" dataType="number" width='6rem' />
                    <Column dataField='batchTypeString' caption="Batch Type" dataType="string" width='12rem' />
                    <Column />

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Referenced Batches</div>
                            </div>
                        </ToolBarItem>
                    </Toolbar>
                </DataGrid>
            </div>

            <div className="pw-comp-row pw-margin-top-1">
                <div className="pw-centered-buttons-container">
                    <Button id="closeButton"
                        className="pw-button"
                        text="Close" type="success"
                        hint="close dialog"
                        height='2.6em'
                        onClick={onCloseClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata}
                    onReply={onGlobalDialogReply} onClose={onGlobalDialogClose} />
            }
        </div>
    );

    function onSearchStringValueChanged(e: any) {
        setSearchString(e.value);
    }

    function onSearchBatchesClick(e: any) {
        if (searchString)
            getBatchesBySearch(searchString);
    }

    function onBatchesSelectionChanged({ selectedRowKeys, selectedRowsData }: any) {
        console.log("onBatchesSelectionChanged");
        console.log(selectedRowKeys);
        console.log(selectedRowsData);

        if (selectedRowsData && selectedRowsData.length > 0) {
            let newSelectedBatches = selectedBatches ? selectedBatches : [];

            newSelectedBatches.push({ batchId: selectedRowsData[0].batchId, benchSheetId: props.benchSheetId });

            setSelectedBatches(newSelectedBatches);
        }
    }

    async function onAddSelectedBatchesClick() {
        console.log("onAddSelectedBatchesClick");
        console.log(selectedBatches);

        if (selectedBatches && selectedBatches.length > 0) {
            await addBatchesBenchSheetEntry(selectedBatches)
                .then(() => {
                    getReferencedBatches();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Adding Batch Bench Sheet Entry");
                });
        }
    }

    async function onRemoveBatchReferenceClick(e: any) {
        //todo - need to make sure there is at least one reference!
        //and need a warning to user here

        if (referencedBatches && referencedBatches.length < 2) {
            showInformationMessage(ModalMessageType.Information, "One Batch Reference", "This batch reference cannot be removed. You must have at least one batch reference.")
            return;
        }

        console.log("onRemoveBatchReferenceClick");
        console.log(e);

        if (e.row && e.row.data && e.row.data.batchId) {
            setDeleteBatchReferenceId(e.row.data.batchId);

            showPromptMessage(ModalMessageType.PromptYesNo,
                "Delete Batch Reference",
                "Are sure you want to delete this batch reference entry?",
                DELETE_BATCHES_BENCH_SHEET_WARNING);
        }
    }

    async function deleteBatchReference() {
        if (deleteBatchReferenceId) {
            await deleteBatchesBenchSheetEntry(deleteBatchReferenceId, props.benchSheetId)
                .then(() => {
                    getReferencedBatches();
                    setDeleteBatchReferenceId(null);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Batch Bench Sheet Entry");
                });
        }
    }

    function onCloseClick() {
        if (props.onClose)
            props.onClose();
    }

    async function getReferencedBatches() {
        if (props.benchSheetId) {
            await CrudFunctions.getData(`benchsheets/referencedbatchesbybenchsheetid/${props.benchSheetId}`)
                .then((data) => {
                    setReferencedBatches(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Batch List");
                });
        }
    }

    async function getBatchesBySearch(batchName: string) {
        await CrudFunctions.getData(`products/batchesbysearch/${batchName}`)
            .then((data) => {
                setBatches(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Batch List");
            });
    }

    async function addBatchesBenchSheetEntry(parentReferences: BenchSheetParentReference[]) {
        return CrudFunctions.postData("benchsheets/batchesbenchsheet", parentReferences);
    }

    async function deleteBatchesBenchSheetEntry(batchId: string, benchSheetId: string) {
        return CrudFunctions.deleteData(`benchsheets/batchesbenchsheet/${batchId}/${benchSheetId}`);
    }

    async function getAllData() {
        await getReferencedBatches();
    }

    function onGlobalDialogReply(reply: MessageBoxReply) {
        if (reply.code === DELETE_BATCHES_BENCH_SHEET_WARNING) {
            clearGlobalDialog();

            if (reply.reply !==  MessageBoxReplyType.Yes)
                return;

            deleteBatchReference();
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showInformationMessage(mode: ModalMessageType, title: string, message: string) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showPromptMessage(mode: ModalMessageType, title: string, message: string, code: number) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message,
            code: code
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }


    function onGlobalDialogClose() {
        clearGlobalDialog();
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}